export const initialFieldValues = {
  firstname: '',
  lastname: '',
  country: '',
  email: '',
  marketing: false,
};
